module.exports = __webpack_public_path__ + "static/7i-81f57861ed4ac74741f5671e1dff2fd9.woff";